import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { AvatarMediaPreview } from 'AdminPanel/SpineAvatars/SpineAvatars/components/AvatarMediaPreview'
import { cdnUrl } from 'commons/cdn'
import { MyImage } from 'components/MyImage'
import {
  getTemplateListItemKind,
  isSpineTemplateItem,
  type TemplateListItem,
} from '../utils/templateList'

const THUMB_CLASS = 'h-[150px] w-[150px] shrink-0'

const FRAME_TYPE_LABEL: Record<string, string> = {
  frame: 'Frame',
  spineFrame: 'Spine Frame',
}

type ThumbProps = {
  imageUrl?: string
  videoUrl?: string
  alt: string
}

function Thumb({ imageUrl, videoUrl, alt }: ThumbProps) {
  const resolvedImage = imageUrl?.trim() ? cdnUrl(imageUrl) : undefined
  const resolvedVideo = videoUrl?.trim() ? videoUrl : undefined

  return (
    <div
      className={`${THUMB_CLASS} overflow-hidden rounded-md border bg-black`}
    >
      {resolvedVideo ? (
        <AvatarMediaPreview
          videoUrl={resolvedVideo}
          imageUrl={imageUrl}
          lazyVideo
          className="h-full w-full"
        />
      ) : resolvedImage ? (
        <MyImage
          src={resolvedImage}
          alt={alt}
          preview
          lazy
          className="h-full w-full object-contain"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-[10px] text-muted-foreground">
          -
        </div>
      )}
    </div>
  )
}

type Props = {
  item: TemplateListItem
}

export default function TemplateListCard({ item }: Props) {
  const isSpine = isSpineTemplateItem(item)
  const kind = getTemplateListItemKind(item)
  const coverUrl = item.coverThumb || item.cover
  const previewUrl = item.previewThumb || item.preview

  return (
    <Card className="overflow-hidden">
      <CardContent className="flex items-start gap-3 p-3">
        <div className="flex shrink-0 gap-2">
          {isSpine ? (
            <>
              <Thumb
                alt={item.name || item.id}
                videoUrl={item.videoCoverPreview}
                imageUrl={coverUrl}
              />
              <Thumb
                alt={item.name || item.id}
                videoUrl={item.videoPreviewPreview}
                imageUrl={previewUrl}
              />
            </>
          ) : (
            <>
              <Thumb alt={`${item.name || item.id} cover`} imageUrl={coverUrl} />
              <Thumb
                alt={`${item.name || item.id} preview`}
                imageUrl={previewUrl}
              />
            </>
          )}
        </div>

        <div className="min-w-0 flex-1 space-y-1">
          <p className="line-clamp-2 font-medium leading-snug">
            {item.name || item.id}
          </p>
          <p className="truncate text-xs text-muted-foreground">{item.id}</p>
          <p className="text-xs text-muted-foreground">
            {FRAME_TYPE_LABEL[kind] ?? kind}
          </p>
          <p className="text-sm text-muted-foreground">
            total reCreate：
            <span className="font-medium text-foreground">
              {item.reCreateCount ?? '-'}
            </span>
          </p>
          <p className="text-sm text-muted-foreground">
            daily reCreate：
            <span className="font-medium text-foreground">
              {item.dailyReCreateCount ?? '-'}
            </span>
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
